const initialState = {
  currentSurvey: undefined,
};

const survey = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CURRENT_SURVEY": {
      const { survey } = action.payload;
      return { ...state, currentSurvey: survey };
    }
    case "ADD_ANSWER": {
      const { answer } = action.payload;
      if (state.currentSurvey.answer) state.currentSurvey.answer.push(answer);
      else state.currentSurvey.answer = [answer];
      return { ...state, currentSurvey: { ...state.currentSurvey } };
    }
    case "CLEAR_STATE":
      return initialState;
    default:
      return state;
  }
};

export default survey;
